import {
  Close,
  DateRange,
  Loop,
  PauseCircleOutline,
  PlayCircleOutline,
} from "@material-ui/icons";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Form, Formik } from "formik";
import moment from "moment";
import React from "react";
import { Button, Col, InputGroup, Modal, Nav, Row, Tab } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import UrlConstants from "../../../config/UrlConstants";
import Documents from "../../Documents/DocumentsNew";
import { getBuyerAgentMasterTemplateAction } from "./../../../actions/BuyerAgentMasterTemplateActions";
import {
  changeTransactionStatusAction,
  getTransactionDataAction,
  getAllTasksAction,
} from "./../../../actions/TransactionActions";
import { getContactsActions } from "../../../actions/UserActions";
import { getSubscriptionCounterAction } from "./../../../actions/SubscriptionReportAction";
import placeholderImage from "./../../../assets/img/property-placeholder.jpg";
import Activity from "./Activity";
import TimelineComponent from "./Timeline";
import noRecord from "./../../../assets/img/no-record.png";
import TransactionDetailTab from "./transaction-detail-tab";
import TransactionTask from "./transaction-task";
import Discussion from "./Discussion/Discussion";
import {
  cryptoTokenDecode,
  getToday,
  toastMessage,
} from "./../../Common/Common";
import * as message from "./../../../config/CommonMessages";
import * as code from "./../../../config/Constants";
import AddTransactionPathway from "./Pathway/AddTransactionPathway";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../config/Constants";
var CryptoJS = require("crypto-js");

var minDate = getToday();

class Detail extends React.Component {
  constructor(props) {
    super(props);
    let userType = cryptoTokenDecode().usertype;
    let currentType = cryptoTokenDecode().roleName;
    this.rerenderParentCallback = this.rerenderParentCallback.bind(this);
    // this.renderBuyerAgent = this.renderBuyerAgent.bind(this);
    this.state = {
      allTransdata: undefined,
      propertyDataInfo: {},
      ownerId: "",
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      transStatus: "SCHEDULED",
      startTransaction: false,
      promptMsg: "",
      initialValues: {
        startDate: "",
        closeDate: "",
      },
      chanedSts: "SCHEDULED",
      showStartDate: true,
      showCloseDate: true,
      campaignStyle: [],
      updated: false,
      activeKey: "first",
      completeTransactionModal: false,
      allTask: [],
      buyerAgent: "",
      buyerAgentId: "",
      permissionArray: [],
    };

    this.props.history.listen((location, action) => {
      //redirection from notification to document, task and discussion
      if (localStorage.getItem("doc")) {
        this.setState(
          {
            activeKey: "fifth",
          },
          () => {
            localStorage.removeItem("doc");
          }
        );
      }

      if (localStorage.getItem("discussion")) {
        this.setState(
          {
            activeKey: "seventh",
            from: localStorage.getItem("from"),
          },
          () => {
            localStorage.removeItem("discussion");
            localStorage.removeItem("from");
          }
        );
      }

      if (localStorage.getItem("taskId")) {
        this.setState(
          {
            activeKey: "second",
            taskId: localStorage.getItem("taskId"),
          },
          () => {
            localStorage.removeItem("taskId");
          }
        );
      }
    });
  }

  componentWillMount() {
    this.rerenderParentCallback();
    // this.renderBuyerAgent();
    this.getUserPermissions();
  }

  componentDidMount() {
    this.getPendingTasks();
  }

  getUserPermissions() {
    let usertype = localStorage.getItem("usertype");
    if (usertype === message.VENDOR) {
      let permission = localStorage.getItem("otherInfo");
      let permissionarray;
      if (permission) {
        let bytes = CryptoJS.AES.decrypt(
          permission,
          REACT_APP_CRYPTO_SECRET_KEY
        );
        let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        permissionarray = decryptedData.split(",");
        this.setState({ permissionArray: permissionarray });
      }
    }
  }

  checkPermission(checkFor) {
    let usertype = localStorage.getItem("usertype");
    if (usertype === message.ACCTOWNER) {
      return true;
    } else {
      const hasSome =
        this.state.permissionArray &&
        this.state.permissionArray.length > 0 &&
        checkFor.some((item) => this.state.permissionArray.includes(item));
      return hasSome;
    }
  }

  /**
   * @desc get pending tasks to show at time of complete transaction
   */
  getPendingTasks() {
    let transId = this.props.match.params.transId;
    this.props
      .getAllTasksAction(transId)
      .then((res) => {
        let tasks = !!res.data ? res.data.data : [];
        let allTask = !!res.data ? res.data.data : [];
        tasks = tasks.filter((e) => {
          return e.status.toLowerCase() == "scheduled";
        });
        this.setState({ pendigTasks: tasks, allTask: allTask });
      })
      .catch((err) => {});
  }

  /**
   * @desc complete transaction appi call
   */
  completeTransactionSuccess() {
    let transId = this.props.match.params.transId;
    let data = { status: "COMPLETED" };
    data.startDate = new Date(this.state.allTransdata.startDate);
    data.endDate = new Date(this.state.allTransdata.endDate);
    this.changeSatusAPI(transId, data);
    this.setState({ completeTransactionModal: false });
  }

  /**
   * @desc change transaction status
   * @param {*} val
   */
  changeTransactionStatus(val) {
    let transId = this.props.match.params.transId;
    let data = { status: this.state.chanedSts };
    data.startDate = new Date(val.startDate);
    data.endDate = new Date(val.closeDate);
    this.changeSatusAPI(transId, data);
  }

  /**
   * @desc call api for change transaction status
   * @param {*} transId
   * @param {*} data
   */
  changeSatusAPI(transId, data) {
    data.endDate = moment(data.endDate).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");

    this.props.changeTransactionStatusAction(transId, data).then((res) => {
      this.props.getTransactionDataAction(transId).then((res) => {
        if (
          this.props.transactionData !== undefined &&
          this.props.transactionData !== null
        ) {
          var dateObj = new Date();
          var n = dateObj.getTimezoneOffset();

          let sdt = new Date(this.props.transactionData.startDate);
          sdt.setMinutes(sdt.getMinutes() + n);

          let edt = new Date(this.props.transactionData.endDate);
          edt.setMinutes(edt.getMinutes() + n);

          let initialValues = {
            startDate: sdt,
            closeDate: edt,
          };

          this.setState({
            allTransdata: res,
            propertyDataInfo: this.props.transactionData.property || {},
            ownerId: this.props.transactionData.ownerId,
            transStatus: this.props.transactionData.status,
            initialValues: initialValues,
            promptMsg: "",
            startTransaction: false,
            updated: true,
          });
          // if (
          //   this.state.userType === message.ACCTOWNER &&
          //   localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
          // ) {
          //   this.props.getSubscriptionCounterAction().then((counterRes) => {
          //     localStorage.setItem(
          //       "transactionCount",
          //       counterRes[0].transactionLimitCounter
          //     );
          //   });
          //   if (
          //     this.state.userType === message.VENDOR &&
          //     this.state.currentRole === message.BUYERAGENT &&
          //     localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
          //   ) {
          //     this.props.getSubscriptionCounterAction().then((counterRes) => {
          //       localStorage.setItem(
          //         "transactionCount",
          //         counterRes[0].transactionLimitCounter
          //       );
          //     });
          //   }
          // }
        }
      });

      this.getPendingTasks();
    });
  }

  /**
   * @desc open confirmation popup for status change
   * @param {*} sts
   */
  openConfirmPopup(sts) {
    let sd = new Date(this.state.initialValues.startDate);
    let ed = new Date(this.state.initialValues.closeDate);

    let d = new Date();
    if (sd.getTime() < d.getTime()) {
      let selectedcamp = this.state.allTransdata.campaign;
      let camDays = 0;
      for (var i = 0, len = this.state.campaignStyle.length; i < len; i++) {
        let camp = this.state.campaignStyle[i];
        if (camp._id === selectedcamp) {
          camDays = camp.campaignDays - 1;
        }
      }

      //close date set based on selected campaign's days
      let ld = moment(d).subtract(-camDays, "days");
      ld = ld.format("YYYY-MM-DD");
      let nld = new Date(ld);
      if (ed.getTime() > nld.getTime()) {
        ld = ed;
      }

      let initialValues = {
        startDate: d,
        closeDate: new Date(ld),
      };
      this.setState({
        initialValues: initialValues,
      });
    }

    let msg = "";
    if (sts === "start") {
      msg = "Please select a new start date and closing date.";
      this.setState({
        showStartDate: true,
        showCloseDate: true,
        chanedSts: "INPROGRESS",
      });
    }

    if (sts === "resume") {
      msg = "Please select a new closing date.";
      this.setState({
        showStartDate: false,
        showCloseDate: true,
        chanedSts: "INPROGRESS",
      });
    }

    if (sts === "cancel") {
      msg =
        "Cancelling a transaction will also cancel all pending tasks. Are you sure you want to do this?";
      this.setState({
        showStartDate: false,
        showCloseDate: false,
        chanedSts: "CANCELED",
      });
    }

    if (msg !== "") {
      this.setState({ promptMsg: msg, startTransaction: true });
    }
  }

  completeTransactionModal() {
    this.setState({ completeTransactionModal: true });
  }
  closeCompleteTransactionModal() {
    this.setState({ completeTransactionModal: false });
  }

  closeConfirmPopup() {
    this.setState({ promptMsg: "", startTransaction: false });
  }

  gotoUserProfile(stateValues) {
    this.props.history.push("/UserProfile/" + this.state.buyerAgentId);
  }

  //update task leader bar if status updated from detais tab component
  updateLeaderBar() {
    this.getPendingTasks();
  }

  // renderBuyerAgent() {

  //   if ((this.state.userType === message.BUYER ||
  //       this.state.currentRole === message.BUYER) ||
  //       (this.state.userType === message.VENDOR ||
  //       this.state.currentRole === message.VENDOR) ||
  //       (this.state.userType === message.VENDOR ||
  //       this.state.currentRole === message.BUYERAGENT))
  //     {

  //     let transID = this.props.match.params.transId;

  //     this.props.getContactsActions('buyer', transID)
  //     .then(res => {
  //       let buyerAgentName = "";
  //       let buyerAgentID = "";
  //       let contactsdata = res.data.data;
  //       for (let i = 0; i < contactsdata.length; i++) {
  //         if (contactsdata[i].roles.includes('62cddf9e169fc5f1c375a83e')) {
  //           buyerAgentName = contactsdata[i].firstname + " " + contactsdata[i].lastname;
  //           buyerAgentID = contactsdata[i].contactId;
  //           this.agentName = buyerAgentName;
  //           this.agentId = buyerAgentID;
  //         }
  //       }
  //       this.setState({
  //         buyerAgent: this.agentName,
  //         buyerAgentId: this.agentId
  //       })
  //     });
  //   }
  // };

  rerenderParentCallback() {
    let transId = this.props.match.params.transId;

    // this.props.getContactsActions("buyer", transId).then((res) => {
    //   console.log("===contact api call from detail jsx");
    //   let buyerAgentName = "";
    //   let buyerAgentID = "";
    //   let contactsdata = res.data.data;
    //   for (let i = 0; i < contactsdata.length; i++) {
    //     if (
    //       contactsdata[i].roles.includes("62cddf9e169fc5f1c375a83e") &&
    //       localStorage.getItem("ID") === contactsdata[i].contactId
    //     ) {
    //       buyerAgentName =
    //         contactsdata[i].firstname + " " + contactsdata[i].lastname;
    //       buyerAgentID = contactsdata[i].contactId;
    //       this.agentName = buyerAgentName;
    //       this.agentId = buyerAgentID;

    //       localStorage.setItem("currentRole", message.BUYERAGENT);

    //       this.setState({
    //         buyerAgent: this.agentName,
    //         buyerAgentId: this.agentId,
    //         currentRole: message.BUYERAGENT,
    //       });
    //     }
    //   }
    // });

    //get transaction data from api
    this.props
      .getTransactionDataAction(transId)
      .then((res) => {
        // console.log("parent randering ");
        if (
          this.props.transactionData !== undefined &&
          this.props.transactionData !== null
        ) {
          var dateObj = new Date();
          var n = dateObj.getTimezoneOffset();

          let sdt = new Date(this.props.transactionData.startDate);
          sdt.setMinutes(sdt.getMinutes() + n);

          let edt = new Date(this.props.transactionData.endDate);
          edt.setMinutes(edt.getMinutes() + n);

          let initialValues = {
            startDate: sdt,
            closeDate: edt,
          };
          this.setState(
            {
              allTransdata: this.props.transactionData,
              propertyDataInfo: this.props.transactionData.property || {},
              ownerId: this.props.transactionData.ownerId,
              transStatus: this.props.transactionData.status,
              initialValues: initialValues,
            },
            () => {
              if (this.props.history.location.taskId !== undefined) {
                this.setState({
                  activeKey: "second",
                });
              }
              if (this.props.history.location.document) {
                this.setState(
                  {
                    activeKey: "fifth",
                  },
                  () => {
                    if (localStorage.getItem("doc")) {
                      localStorage.removeItem("doc");
                    }
                  }
                );
              }

              if (this.props.history.location.discussion) {
                this.setState(
                  {
                    activeKey: "seventh",
                  },
                  () => {
                    localStorage.removeItem("discussion");
                  }
                );
              }
            }
          );
        }
      })
      .catch((err) => {
        /*if api fails then no need to update state*/
      });
    //get buyer agent master templates
    this.props
      .getBuyerAgentMasterTemplateAction()
      .then((res) => {
        this.setState({ campaignStyle: this.props.buyerMasterTemplates });
      })
      .catch((err) => {});
  }

  render() {
    let transId = this.props.match.params.transId;

    let img = "";

    if (this.state.propertyDataInfo !== undefined) {
      let imgs = this.state.propertyDataInfo.image;
      if (imgs !== undefined && imgs.length > 0) {
        img = this.state.propertyDataInfo.image[0];
      }
    }

    let sts = "";
    if (
      this.state.userType == message.ACCTOWNER ||
      this.state.userType === message.ADMIN ||
      this.state.currentRole === message.ACCTOWNER
    ) {
      if (this.state.transStatus === "INPROGRESS") {
        sts = (
          <div>
            <Button
              variant="primary"
              className="btn-blue font-14 ml-2 p-1"
              onClick={() => {
                // if (localStorage.getItem("isActive") === "false") {
                //   toastMessage(code.ERROR, message.SUBSCRIPTION_NOT_ACTIVE);
                // } else {
                //   this.completeTransactionModal();
                // }

                this.completeTransactionModal();
              }}
            >
              Complete
            </Button>
          </div>
        );
      }

      if (this.state.transStatus === "CANCELED") {
        sts = (
          <div>
            {" "}
            <Button
              variant="primary"
              className="btn-blue font-14 ml-2 p-1"
              onClick={() => {
                // if (localStorage.getItem("isActive") === "false") {
                //   toastMessage(code.ERROR, message.SUBSCRIPTION_NOT_ACTIVE);
                // } else {
                //   this.completeTransactionModal();
                // }

                this.completeTransactionModal();
              }}
            >
              Complete
            </Button>
          </div>
        );
      }
    }

    if (!!this.state.allTransdata && this.state.allTransdata.length === 0) {
      return (
        <div className="no-transaction no-record">
          <div className="no-transaction-inner">
            <img src={noRecord} alt="no record" />
            <p>No transaction found</p>
          </div>
        </div>
      );
    } else {
      if (!!this.state.allTransdata) {
        return (
          <div>
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey="first"
              activeKey={this.state.activeKey}
              onSelect={(k) => {
                this.props.history.location.taskId = undefined;
                this.setState({ activeKey: k });
              }}
              mountOnEnter={true}
              unmountOnExit={true}
              forceRenderTabPanel={true}
            >
              <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
                <Col xs="12" sm="3">
                  <div className="trans-combo align-items-center">
                    <div className="trans-img">
                      <img
                        src={
                          img != ""
                            ? UrlConstants.AdminCreateTransactionUrl +
                              "/upload?id=" +
                              this.state.ownerId +
                              "&img=" +
                              img
                            : placeholderImage
                        }
                        alt=""
                      />
                    </div>
                    <div className="trans-info">
                      <h5 style={{ color: "white", fontWeight: "bold" }}>
                        {this.state.allTransdata.dsd.buyer[0].firstname +
                          (this.state.allTransdata.dsd.buyer[0].lastname
                            ? " " +
                              this.state.allTransdata.dsd.buyer[0].lastname
                            : "")}
                      </h5>
                      <p style={{ color: "white" }}>
                        {this.state.allTransdata.transactionType +
                          (this.state.allTransdata.dsd.heldBy
                            ? " - " + this.state.allTransdata.dsd.heldBy
                            : "")}
                      </p>
                    </div>
                  </div>
                </Col>
                {this.state.userType !== message.VENDOR ||
                this.state.currentRole !== message.VENDOR ? (
                  <Col xs="12" sm="6">
                    {(this.state.userType === message.VENDOR &&
                      this.state.currentRole == message.BUYER) ||
                    (this.state.userType === message.BUYER &&
                      this.state.currentRole == message.BUYER) ? (
                      <Nav className="justify-content-center align-items-end trans-tabs">
                        <Nav.Item>
                          <Nav.Link eventKey="first">Overview</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="second">Tasks</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="fifth">Documents</Nav.Link>
                        </Nav.Item>
                      </Nav>
                    ) : (
                      <Nav className="justify-content-center align-items-end trans-tabs">
                        <Nav.Item>
                          <Nav.Link eventKey="first">Overview</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="second">Tasks</Nav.Link>
                        </Nav.Item>
                        {/* <Nav.Item className="hide-991">
                            <Nav.Link eventKey="third">Timeline</Nav.Link>
                          </Nav.Item> */}
                        <Nav.Item>
                          <Nav.Link eventKey="fifth">Documents</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="hide-991">
                          <Nav.Link eventKey="sixth">Activity</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="seventh">Discussion</Nav.Link>
                        </Nav.Item>
                        {this.checkPermission([
                          message.view_pathway,
                          message.manage_pathway,
                        ]) && (
                          <Nav.Item>
                            <Nav.Link eventKey="eighth">Pathway</Nav.Link>
                          </Nav.Item>
                        )}
                      </Nav>
                    )}
                  </Col>
                ) : (
                  ""
                )}
                {this.state.userType === message.VENDOR &&
                this.state.currentRole === message.VENDOR ? (
                  <Col xs="12" sm="6">
                    <Nav className="justify-content-center align-items-end trans-tabs">
                      <Nav.Item>
                        <Nav.Link eventKey="first">Overview</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Tasks</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="fifth">Documents</Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                ) : (
                  ""
                )}

                <Col xs="12" sm="3">
                  <div className="d-flex justify-content-end align-items-center switch-div">
                    <div>
                      {this.state.userType === message.VENDOR ||
                      this.state.userType === message.BUYER ||
                      this.state.userType !== message.ACCTOWNER ? (
                        ""
                      ) : (
                        <div>{sts}</div>
                      )}
                    </div>

                    <Link
                      to="/artwork"
                      className="nav-link p-0 color-black sep-left"
                    >
                      <Close
                        style={{
                          stroke: "#fff",
                          height: "40px",
                          width: "40px",
                        }}
                      />
                    </Link>
                  </div>
                </Col>
              </Row>
              <div className="trans-tab-content">
                {this.state.userType === message.VENDOR &&
                this.state.currentRole === message.VENDOR ? (
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <TransactionDetailTab
                        transactionId={transId}
                        isDataUpdate={(data) =>
                          this.setState({
                            propertyDataInfo: data,
                          })
                        }
                        isTransactionUpdate={(data) => {
                          let initialValues = {
                            startDate: data.startDate,
                            closeDate: data.endDate,
                          };

                          this.setState({
                            allTransdata: data,
                            initialValues: initialValues,
                          });
                        }}
                        setTransSts={(transStatus) =>
                          this.setState({ transStatus: transStatus })
                        }
                        transStatus={this.state.transStatus}
                        updatedData={this.state.allTransdata}
                        updated={this.state.updated}
                        completeTransaction={() => {
                          this.completeTransactionModal();
                        }}
                        allTask={this.state.allTask}
                        updateLeaderBar={this.updateLeaderBar}
                        currentRole={this.state.currentRole}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <TransactionTask
                        transactionId={transId}
                        history={this.props.history}
                        transactionData={this.state.allTransdata}
                        rerenderParentCallback={this.rerenderParentCallback}
                      />
                    </Tab.Pane>

                    <Tab.Pane eventKey="fifth">
                      <Documents
                        transactionId={transId}
                        isNotification={this.props.location.notification}
                        transactionData={this.state.allTransdata}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="seventh">
                      <Discussion
                        transactionId={transId}
                        history={this.props.history}
                        transactionData={this.state.allTransdata}
                      />
                    </Tab.Pane>
                  </Tab.Content>
                ) : (
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <TransactionDetailTab
                        transactionId={transId}
                        isDataUpdate={(data) =>
                          this.setState({
                            propertyDataInfo: data,
                          })
                        }
                        isTransactionUpdate={(data) => {
                          let initialValues = {
                            startDate: data.startDate,
                            closeDate: data.endDate,
                          };

                          this.setState({
                            allTransdata: data,
                            initialValues: initialValues,
                          });
                        }}
                        setTransSts={(transStatus) =>
                          this.setState({ transStatus: transStatus })
                        }
                        transStatus={this.state.transStatus}
                        updatedData={this.state.allTransdata}
                        updated={this.state.updated}
                        completeTransaction={() => {
                          this.completeTransactionModal();
                        }}
                        allTask={this.state.allTask}
                        updateLeaderBar={this.updateLeaderBar}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <TransactionTask
                        transactionId={transId}
                        history={this.props.history}
                        transactionData={this.state.allTransdata}
                        taskId={this.state.taskId}
                        rerenderParentCallback={this.rerenderParentCallback}
                      />
                    </Tab.Pane>
                    {/* <Tab.Pane eventKey="third" transactionId={transId}>
                        <TimelineComponent
                          transactionId={transId}
                          transactionData={this.state.allTransdata}
                        />
                      </Tab.Pane> */}

                    <Tab.Pane eventKey="fifth">
                      <Documents
                        isNotification={this.props.location.notification}
                        transactionId={transId}
                        transactionData={this.state.allTransdata}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="sixth">
                      <Activity
                        transactionId={transId}
                        transactionData={this.state.allTransdata}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="seventh">
                      <Discussion
                        transactionId={transId}
                        history={this.props.history}
                        transactionData={this.state.allTransdata}
                        from={this.state.from}
                      />
                    </Tab.Pane>
                    {this.checkPermission([
                      message.view_pathway,
                      message.manage_pathway,
                    ]) && (
                      <Tab.Pane eventKey="eighth">
                        <AddTransactionPathway
                          transactionId={transId}
                          history={this.props.history}
                          transactionData={this.state.allTransdata}
                          transStatus={this.state.transStatus}
                        />
                      </Tab.Pane>
                    )}
                  </Tab.Content>
                )}
              </div>
            </Tab.Container>

            {/* Start transaction Confirmation */}
            <Modal
              show={this.state.startTransaction}
              onHide={() => this.closeConfirmPopup()}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med"
            >
              <Formik
                validateOnBlur={true}
                initialValues={this.state.initialValues}
                enableReinitialize={true}
                //Validation schema
                validationSchema={Yup.object().shape({})}
                //Form submit method
                onSubmit={(values) => {
                  this.changeTransactionStatus(values);
                }}
              >
                {({ errors, values, setFieldValue }) => (
                  <Form className="form-sm form-admin">
                    <Modal.Header closeButton>
                      <Modal.Title id="example-custom-modal-styling-title">
                        Update Transaction
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pb-0">
                      <div>
                        <p className="font-20 color-black mb-2">
                          {this.state.promptMsg}
                        </p>
                      </div>

                      {this.state.showStartDate && this.state.showCloseDate && (
                        <Row>
                          <Col xs={12} sm={6}>
                            <div className="form-group">
                              <label className="form-label" htmlFor="emd">
                                Contract/Escrow Date
                                <span className="text-danger">*</span>
                              </label>

                              <InputGroup className="icon-wrapper blue-wrapper">
                                <DateRangePicker
                                  singleDatePicker
                                  startDate={moment(values.startDate)}
                                  onEvent={(e, picker) => {
                                    setFieldValue(
                                      "startDate",
                                      picker.startDate.format("YYYY-MM-DD")
                                    );

                                    let selectedcamp = this.state.allTransdata
                                      .campaign;
                                    let camDays = 0;
                                    for (
                                      var i = 0,
                                        len = this.state.campaignStyle.length;
                                      i < len;
                                      i++
                                    ) {
                                      let camp = this.state.campaignStyle[i];
                                      if (camp._id === selectedcamp) {
                                        camDays = camp.campaignDays - 1;
                                      }
                                    }

                                    let edate = picker.startDate.subtract(
                                      -camDays,
                                      "days"
                                    );
                                    setFieldValue(
                                      "closeDate",
                                      edate.format("YYYY-MM-DD")
                                    );
                                  }}
                                  minDate={minDate}
                                >
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="MM/DD/YYYY"
                                    value={moment(values.startDate).format(
                                      "MM/DD/YYYY"
                                    )}
                                  />
                                  <span className="form-control-icn form-control-icn-sm">
                                    <DateRange />
                                  </span>
                                </DateRangePicker>
                              </InputGroup>
                            </div>
                          </Col>

                          <Col xs={12} sm={6}>
                            <div className="form-group">
                              <label className="form-label" htmlFor="emd">
                                Expected Closing Date
                                <span className="text-danger"> *</span>
                              </label>
                              <InputGroup className="icon-wrapper blue-wrapper">
                                <DateRangePicker
                                  singleDatePicker
                                  startDate={moment(values.closeDate)}
                                  onEvent={(e, picker) => {
                                    setFieldValue(
                                      "closeDate",
                                      picker.startDate.format("YYYY-MM-DD")
                                    );
                                  }}
                                  minDate={moment(values.startDate)}
                                >
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="MM/DD/YYYY"
                                    value={moment(values.closeDate).format(
                                      "MM/DD/YYYY"
                                    )}
                                  />

                                  <span className="form-control-icn form-control-icn-sm">
                                    <DateRange />
                                  </span>
                                </DateRangePicker>
                              </InputGroup>
                            </div>
                          </Col>
                        </Row>
                      )}

                      {this.state.showStartDate && !this.state.showCloseDate && (
                        <Row>
                          <Col xs={12} sm={6}>
                            <div className="form-group">
                              <label className="form-label" htmlFor="emd">
                                Contract/Escrow Date
                                <span className="text-danger">*</span>
                              </label>

                              <InputGroup className="icon-wrapper blue-wrapper">
                                <DateRangePicker
                                  singleDatePicker
                                  startDate={moment(values.startDate)}
                                  onEvent={(e, picker) => {
                                    setFieldValue(
                                      "startDate",
                                      picker.startDate.format("YYYY-MM-DD")
                                    );
                                  }}
                                >
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="MM/DD/YYYY"
                                    value={moment(values.startDate).format(
                                      "MM/DD/YYYY"
                                    )}
                                  />
                                  <span className="form-control-icn form-control-icn-sm">
                                    <DateRange />
                                  </span>
                                </DateRangePicker>
                              </InputGroup>
                            </div>
                          </Col>
                        </Row>
                      )}

                      {!this.state.showStartDate && this.state.showCloseDate && (
                        <Row>
                          <Col xs={12} sm={6}>
                            <div className="form-group">
                              <label
                                className="form-label"
                                htmlFor="expCloseDate"
                              >
                                Expected Closing Date
                                <span className="text-danger">*</span>
                              </label>
                              <InputGroup
                                className="icon-wrapper blue-wrapper"
                                name="expCloseDate"
                              >
                                <DateRangePicker
                                  singleDatePicker
                                  startDate={moment(values.closeDate)}
                                  minDate={minDate}
                                  onEvent={(e, picker) => {
                                    setFieldValue(
                                      "closeDate",
                                      picker.startDate.format("YYYY-MM-DD")
                                    );
                                  }}
                                  name="expCloseDate"
                                >
                                  <input
                                    type="text"
                                    name="expCloseDate"
                                    className="form-control"
                                    placeholder="MM/DD/YYYY"
                                    value={moment(values.closeDate).format(
                                      "MM/DD/YYYY"
                                    )}
                                  />

                                  <span className="form-control-icn form-control-icn-sm">
                                    <DateRange />
                                  </span>
                                </DateRangePicker>
                              </InputGroup>
                              <div
                                className="invalid-feedback"
                                style={{ display: "block" }}
                              >
                                {errors.closeDate}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="primary"
                        className="btn-blue btn-outlined w-140"
                        onClick={() => this.closeConfirmPopup()}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="primary"
                        className="btn-blue w-140"
                      >
                        Yes
                      </Button>
                    </Modal.Footer>
                  </Form>
                )}
              </Formik>
            </Modal>

            {/* Complete transaction Confirmation */}
            <Modal
              show={this.state.completeTransactionModal}
              onHide={() => this.closeCompleteTransactionModal()}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med"
            >
              <Modal.Body className="pb-0">
                <p className="text-center font-20 color-dark-blue">
                  The below tasks are not completed yet. Are you sure you want
                  to mark them as done and close the artwork?
                </p>

                {this.state.pendigTasks && this.state.pendigTasks.length > 0 ? (
                  <div className="px-1">
                    <ul className="dependency-modal-task-list font-12">
                      {this.state.pendigTasks.map((t, i) => {
                        return (
                          <li key={t._id}>
                            {" "}
                            {moment(t.eventEndDate).format(
                              "MM/DD/YYYY hh:mm a"
                            )}{" "}
                            - {t.title}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </Modal.Body>
              <Modal.Footer className="justify-content-center pt-2">
                <Button
                  variant="primary"
                  className="btn-blue btn-outlined w-140"
                  onClick={() => this.closeCompleteTransactionModal()}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="primary"
                  className="btn-blue w-140"
                  onClick={() => this.completeTransactionSuccess()}
                >
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        );
      } else {
        return (
          <div className="page-loader fixed">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        );
      }
    }
  }
}

const mapStateToProps = (state) => {
  return {
    buyerMasterTemplates: state.reducer.buyerMasterTemplates,
    transactionData: state.reducer.transactionData,
    transactionStatus: state.reducer.transactionStatus,
    contacts: state.reducer.contacts,
  };
};

export default connect(
  mapStateToProps,
  {
    getTransactionDataAction,
    changeTransactionStatusAction,
    getBuyerAgentMasterTemplateAction,
    getAllTasksAction,
    getSubscriptionCounterAction,
    getContactsActions,
  }
)(Detail);
